import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import HeaderBase, {
  NavLinks,
  NavLink,
  PrimaryLink,
} from "components/headers/light.js";
import { SectionHeading } from "components/misc/Headings.js";
import {
  SectionDescription,
  SectionDescriptionRTL,
} from "components/misc/Typography.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import {
  Container,
  ContentWithVerticalPadding,
} from "components/misc/Layouts.js";
import { ReactComponent as CheckboxIcon } from "feather-icons/dist/icons/check-circle.svg";
import { ReactComponent as QuotesLeftIconBase } from "images/quotes-l.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/dot-pattern.svg";

// ✅ Styled Login Button using primary color
const StyledPrimaryLink = styled(PrimaryLink)`
  background-color: var(--primary-color) !important;
  color: white !important;
  font-size: 18px;
  padding: 0.75rem 2rem;
  font-family: "CustomFont", sans-serif;
  font-weight: 600;
  border-radius: 9999px;

  &:hover {
    background-color: #102813;
  }
`;

const Header = styled(HeaderBase)`
  ${tw`max-w-none sticky top-0 z-50 bg-white shadow-md`}
  transition: all 0.3s ease-in-out;
`;
const Row = tw.div`flex flex-col lg:flex-row justify-between items-center lg:pt-16 max-w-screen-2xl mx-auto sm:px-8`;
const Column = tw.div``;
const TextColumn = tw(
  Column
)`mr-auto lg:mr-0 max-w-lg lg:max-w-xl xl:max-w-2xl`;
const Heading = tw(
  SectionHeading
)`text-left text-primary-500 leading-snug xl:text-6xl`; // ✅ text-primary
const Description = tw(
  SectionDescription
)`mt-4 lg:text-base text-gray-700 max-w-lg text-right`;
const PrimaryButton = tw(
  PrimaryButtonBase
)`mt-8 inline-block w-56 tracking-wide text-center py-5 bg-primary-500 hover:bg-primary-700 text-white`; // ✅ bg-primary
const FeatureList = tw.ul`mt-12 leading-loose`;
const Feature = tw.li`flex items-center`;
const FeatureIcon = tw(CheckboxIcon)`w-5 h-5 text-primary-500`; // ✅ icon colored
const FeatureText = tw.p`ml-2 font-medium text-gray-700`;
const ImageColumn = tw(Column)`ml-auto lg:mr-0 relative mt-16 lg:mt-0 lg:ml-32`;
const ImageContainer = tw.div`relative z-40 transform xl:-translate-x-24 xl:-translate-y-16`;
const Image = tw.img`max-w-full w-96 rounded-t sm:rounded relative z-20`;
const Offsetbackground = tw.div`absolute inset-0 bg-gray-300 rounded xl:-mb-8`;
const ImageDecoratorBlob = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none z-10 absolute right-0 bottom-0 transform translate-x-10 translate-y-10 h-32 w-32 opacity-25 text-primary-500 fill-current`}// ✅ blob color
`;
const Testimonial = tw.div`max-w-sm rounded-b md:rounded-none relative sm:absolute bottom-0 inset-x-0 z-20 px-8 py-6 sm:px-10 sm:py-8 bg-primary-900 text-gray-100 font-medium transform md:-translate-x-32 text-sm leading-relaxed md:-mr-16 xl:mr-0`; // ✅ dark green bg
const QuotesLeftIcon = tw(
  QuotesLeftIconBase
)`w-16 h-16 md:w-12 md:h-12 absolute top-0 left-0 text-primary-100 transform translate-x-1 md:-translate-x-1/2 md:-translate-y-5 opacity-10 md:opacity-100`; // ✅ icon shade
const Quote = tw.blockquote``;
const CustomerName = tw.p`mt-4 font-bold text-right text-primary-500`; // ✅ name text color
const CustomerCompany = tw.p`mt-1 text-sm text-primary-300`; // ✅ company text color

const StyledNavLink = styled(NavLink)`
  ${tw`transition-all duration-300 ease-in-out`}
  &:hover {
    transform: translateY(-2px);
  }
`;

export default () => {
  const buttonRoundedCss = true && tw`rounded-full`;

  const navLinks = [
    <NavLinks key={1}>
      <StyledNavLink href="/">Home</StyledNavLink>
      <StyledNavLink href="/Magazine">Magazines</StyledNavLink>
      <StyledNavLink href="/Departments">Departments</StyledNavLink>
      <StyledNavLink href="/Alumni">Alumni</StyledNavLink>
      <StyledNavLink href="/Donation">Donations</StyledNavLink>
      <StyledNavLink href="/Events">Events</StyledNavLink>
      <StyledNavLink href="/Admission">Admission</StyledNavLink>
      <StyledNavLink href="/photo-gallery">Photo Gallery</StyledNavLink>
      <StyledNavLink target="_blank" href="https://www.youtube.com/jmardg">
        Videos
      </StyledNavLink>
      <StyledNavLink href="/About">About</StyledNavLink>
    </NavLinks>,
    <NavLinks key={2}>
      <StyledPrimaryLink
        css={buttonRoundedCss}
        href="/Login"
        tw="mx-2 my-2 lg:ml-12!"
      >
        Login
      </StyledPrimaryLink>
    </NavLinks>,
  ];

  return <Header links={navLinks} />;
};
